import { loadChurnkey } from '../../services/churnkey';

const fetchAuth = async () => {
  const { data } = await axios.post('/ajax/v2/settings/package/cancel-flow/auth');
  return data;
};

const recordCancellation = async (surveyResponse, freeformFeedback) => {
  await axios.post('/ajax/v2/settings/package/cancel-flow/cancellation', {
    survey_response: surveyResponse,
    freeform_feedback: freeformFeedback,
  });
};

export const useCancelFlow = (organisationId) => {
  const launchCancelFlow = async () => {
    const auth = await fetchAuth();

    await loadChurnkey(auth.app_id);

    window.churnkey.init('show', {
      customerId: auth.customer_id,
      authHash: auth.auth_hash,
      subscriptionId: auth.subscription_id,
      appId: auth.app_id,
      mode: auth.mode,
      provider: 'stripe',
      onStepChange: (newStep, oldStep) => {
        if (!oldStep) {
          window.mixpanel('Churnkey: View cancel flow', { organisation_id: organisationId });
        }
      },
      onDiscount: () => {
        window.mixpanel('Churnkey: Recovered with discount', { organisation_id: organisationId });
      },
      onCancel: async (customer, surveyResponse, freeformFeedback) => {
        try {
          await recordCancellation(surveyResponse || 'Unknown', freeformFeedback);
          window.mixpanel('Churnkey: Cancelled', { organisation_id: organisationId });
        } catch (error) {
          console.error('Failed to record cancellation:', error);
        }
      },
      onClose: async () => {
        await window.mixpanel('Churnkey: Closed', {organisation_id: organisationId});
        window.location.href = '/settings#billing';
      },
    });
  };

  return {
    launchCancelFlow,
  };
};
